import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/social-media/github.png'
import _imports_1 from '@/assets/img/arweaveSmall.png'
import _imports_2 from '@/assets/img/social-media/communitySmall.png'
import _imports_3 from '@/assets/img/social-media/discord0.png'
import _imports_4 from '@/assets/img/warpLogoSmall.png'
import _imports_5 from '@/assets/img/arconnect.png'
import _imports_6 from '@/assets/img/social-media/spheronSmall.png'


const _withScopeId = n => (_pushScopeId("data-v-2ab7ad99"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title" }, " Help and info ", -1))
const _hoisted_2 = { class: "links-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Useful Links", -1))
const _hoisted_4 = { class: "links-menu" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    tabindex: "0",
    href: "https://github.com/luckyr13/arcode",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "invert-colors",
      src: _imports_0
    }),
    /*#__PURE__*/_createElementVNode("span", null, "ArCode GitHub")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "invert-colors",
  src: _imports_1
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ArCode Gallery", -1))
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://github.com/luckyr13/arcode#common-arcode-problems\" target=\"_blank\" data-v-2ab7ad99><img class=\"invert-colors\" src=\"" + _imports_0 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>ArCode Known Issues</span></a></li><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://community.xyz/#XFZxNNpgb043Doa7-4sra5dnbBB5RkOHRyQJ_YOzLAg\" target=\"_blank\" data-v-2ab7ad99><img src=\"" + _imports_2 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>ArCode Community</span></a></li><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://discord.gg/KMjZkkWrSS\" target=\"_blank\" data-v-2ab7ad99><img src=\"" + _imports_3 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>Discord Channel</span></a></li><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://sonar.warp.cc/\" target=\"_blank\" data-v-2ab7ad99><img src=\"" + _imports_4 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>SonAR Scanner</span></a></li><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://github.com/warp-contracts/warp\" target=\"_blank\" data-v-2ab7ad99><img src=\"" + _imports_4 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>Warp SDK</span></a></li><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://github.com/textury/arlocal\" target=\"_blank\" data-v-2ab7ad99><img class=\"invert-colors\" src=\"" + _imports_1 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>arLocal</span></a></li><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://arwiki.wiki\" target=\"_blank\" data-v-2ab7ad99><img class=\"invert-colors\" src=\"" + _imports_1 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>Arweave ArWiki</span></a></li>", 7)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<h4 data-v-2ab7ad99>Best Arweave Wallets</h4><ul class=\"links-menu\" data-v-2ab7ad99><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://arweave.app\" target=\"_blank\" data-v-2ab7ad99><img class=\"invert-colors\" src=\"" + _imports_1 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>Arweave.app Wallet</span></a></li><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://arconnect.io\" target=\"_blank\" data-v-2ab7ad99><img src=\"" + _imports_5 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>ArConnect Wallet</span></a></li></ul><h4 data-v-2ab7ad99> ArCode Warranty Info </h4><h4 class=\"text-center\" data-v-2ab7ad99> No Warranty </h4><p class=\"text-center sm-text\" data-v-2ab7ad99> &quot;As-Is&quot;. The Software is provided &quot;as is,&quot; with all faults, defects, bugs, and errors. </p><h4 data-v-2ab7ad99>Powered by</h4><ul class=\"links-menu\" data-v-2ab7ad99><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://arweave.org\" target=\"_blank\" data-v-2ab7ad99><img class=\"invert-colors\" src=\"" + _imports_1 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>Arweave</span></a></li><li data-v-2ab7ad99><a tabindex=\"0\" href=\"https://spheron.network/\" target=\"_blank\" data-v-2ab7ad99><img src=\"" + _imports_6 + "\" data-v-2ab7ad99><span data-v-2ab7ad99>Spheron</span></a></li></ul>", 7)


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpInfo',
  setup(__props) {

// import { computed } from 'vue';
// import { ArweaveWrapper } from '@/core/ArweaveWrapper';

// const arweaveWrapper = new ArweaveWrapper();
// const arweave = arweaveWrapper.arweave;
/*
const props = defineProps({
	tokenState: Object,
	mainAddress: String
});
*/
/*
const contractSettings = computed(() => {
	const settings = props.tokenState.settings ? props.tokenState.settings : [];
	return new Map(settings);
});
*/
/*
const appFeeInWinston = computed(() => {
	return contractSettings.value.get('appFeeInWinston');
});
*/
/*
const appFeeInAr = computed(() => {
	return parseFloat(arweave.ar.winstonToAr(appFeeInWinston.value));
});
*/
/*
const vipMinimumBalance = computed(() => {
	return contractSettings.value.get('vipMinimumBalance');
});
*/

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            tabindex: "0",
            to: "/gallery"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _hoisted_8
      ]),
      _hoisted_15
    ])
  ], 64))
}
}

})